module.exports = __webpack_public_path__ + "img/corridor-end.7692089a.svg";